module.exports = __webpack_public_path__ + "static/img/legend_xg_english_vertical.ff5d485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg_english_vertical.png
// module id = 6yIz
// module chunks = 94